import Vue from 'vue'
import Vuex from 'vuex'

import faq from "./faq"

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    currentStep: 0,
    totalSteps: 0,
    validation: null,
    questions: [],
    repairServices: [],
    selectedRepairServices: [],
    checkoutFormData: {
      images: [],
      contact: []
    },
    overviewData: {},
    conditionDescription: null,
    warrantyImage: [],
    warrantyPriceIsCalculated: false,
    watchProtectionImage: [],
    watchProtectionImagePriceIsCalculated: false,
    orderProtectionInfo: {},
    afterLoad: false,
    recaptchaScore: null
  },
  mutations: {
    clear(state) {
      state.currentStep = 0,
      state.totalSteps = 0,
      state.validation = null,
      state.questions = [],
      state.repairServices = [],
      state.selectedRepairServices = [],
      state.checkoutFormData = {
        images: [],
        contact: []
      };
      state.overviewData = {},
      state.warrantyImage = [],
      state.watchProtectionImage = [],
      state.orderProtectionInfo = {},
      state.conditionDescription = null,
      state.warrantyPriceIsCalculated = false,
      state.watchProtectionImagePriceIsCalculated = false,
      state.afterLoad = false
    },
    setCurrentStep (state, step) {
      state.currentStep = step
    },
    setTotalSteps (state, steps) {
      state.totalSteps = steps
    },
    setValidation (state, data) {
      state.validation = data
    },
    updateCheckoutFormData (state, data) {
      state.checkoutFormData = data
    },
    addQuestion (state, data) {
      state.questions.unshift(data)
    },
    updateSelectedAnswers (state, data) {
      state.questions[0].selectedAnswers = data
    },
    clearSelectedAnswers (state){
      state.questions[0].selectedAnswers = []
    },
    setRepairServices (state, data) {
      state.repairServices = data
    },
    setSelectedRepairServices (state, data) {
      state.selectedRepairServices = data
    },
    setOverview (state, data) {
      state.overviewData = data;
    },
    setWatchProtectionImage (state, data) {
      state.watchProtectionImage = data;
    },
    setOrderProtectionInfo(state, data){
      state.orderProtectionInfo = data;
    },
    setWarrantyImage (state, data) {
      state.warrantyImage = data;
    },
    setWatchProtectionPriceIsCalculated(state, value) {
      state.watchProtectionImagePriceIsCalculated = value;
    },
    setWarrantyPriceIsCalculated(state, value){
      state.warrantyPriceIsCalculated = value;
    },
    setConditionDescription(state, value){
      state.conditionDescription = value;
    },
    setAfterLoad(state, value){
      state.afterLoad = value;
    },
    setRecaptchaScore(state, value){
      state.recaptchaScore = value;
    }
  },
  getters: {
    isValid: state => {
      return state.validation ? !state.validation.formData.$invalid : false
    },
    diagnosis (state) {
      const length = state.questions.length
      return length ? state.questions[length - 1].diagnosis : {}
    },
    isClock(state) {
      const question = state.questions.slice(-1)[0];
      return question?.selectedAnswers === 'uhr'
    },
    isJewelry(state) {
      const question = state.questions.slice(-1)[0];
      return question?.selectedAnswers === 'schmuck'
    },
  },
  actions: {},
  modules: {
    faq
  }
})

export default store
